import React from 'react'
import { BubbleAction, BubbleActionProps } from '../../components/BubbleAction'

export const getBubble = (prop: BubbleActionProps) => <BubbleAction {...prop} />
